import React, { useEffect } from 'react';
import { useTranslation } from 'react-multi-lang';
import { useDispatch, useSelector } from 'react-redux';
import DetailsModal from '../../../components/DetailsModal/DetailsModal';

import { addMaterialSlice } from '../AddModal/AddModalSlice';
import { showMaterialSlice, showMaterialState } from './ShowModalSlice';
import { havePermission } from '../../../services/hoc/permissions';
import { Confirm } from '../../../components/Alerts/Alerts';
import { materialsSlice } from '../MaterialsSlice';

import { useAPI } from '../../../services/hoc/useAPI';
import { attribute } from '../../Services/ShowModal/ShowModal';

const ShowMaterial = ({close}:{close:Function}) => {
  // Translation
  const t = useTranslation();

  // Redux
  const dispatch = useDispatch();
  const state = useSelector(
    (state: { show_material: showMaterialState }) => state.show_material,
  );

const ENDPOINTS = useAPI()

  const toggle = () =>
   { dispatch(
      showMaterialSlice.actions.setIsOpen({ id: state.id, isOpen: false }),
    );
    close()
  }

  const fetchData = () => {
    ENDPOINTS.components('material')
      .show({ id: state.id })
      .then((response: any) => {
        dispatch(showMaterialSlice.actions.setIsLoaded(true));
        dispatch(
          showMaterialSlice.actions.setData({
            name: response.data.data.name,
            description: response.data.data.description,
            serial_number: response.data.data.serial_no,
            attributes: response.data.data.attributes_list,
          }),
        );
      });
  };

  // Delete
  const remove = (id: number) => {
    let ids = [id];
    dispatch(materialsSlice.actions.setIsLoading(true));
    ENDPOINTS.components('material')
      .delete({ ids })
      .then(() => {
        toggle();
        dispatch(materialsSlice.actions.setIsLoading(false));
        dispatch(materialsSlice.actions.deleteMaterials(ids));
      });
  };

  // Fix predefined format
  const fixPredefinedFormat = (attributes: attribute[]): attribute[] => {
    attributes = attributes.map((attribute) => {
      if (attribute.type === 'Pre-defined') {
        attribute.items = attribute.items?.map((item: any) => item.name);
      }
      return attribute;
    });
    return attributes;
  };

  useEffect(() => {
    dispatch(showMaterialSlice.actions.setIsLoaded(false));
    if (state.id !== 0) fetchData();
  }, [state.id]);

  return (
    <DetailsModal
      data={(({ attributes, product_attributes, ...data }) => data)(state.data)}
      isOpen={state.isOpen}
      isLoading={!state.isLoaded}
      toggle={toggle}
      title={t('material_details')}
      product_attributes={state.data.product_attributes}
      attributes={state.data.attributes}
      actions={
        <div>
          {havePermission('Edit Component') ? (
            <i
              className="icon-edit"
              onClick={(e: React.MouseEvent<HTMLLIElement>) => {
                e.stopPropagation();
                toggle();
                dispatch(addMaterialSlice.actions.setIsOpen(true));
                dispatch(addMaterialSlice.actions.setIsLoading(true));
                dispatch(addMaterialSlice.actions.setEditId(state.id));
                ENDPOINTS.components('material')
                  .show({ id: state.id })
                  .then((response: any) => {
                    dispatch(
                      addMaterialSlice.actions.set({
                        attributes: fixPredefinedFormat(
                          response.data.data.attributes_list,
                        ),
                        description: response.data.data.description,
                        name: response.data.data.name,
                        serial_number: response.data.data.serial_no,
                      }),
                    );
                    dispatch(addMaterialSlice.actions.setIsLoading(false));
                  });
              }}
            />
          ) : (
            ''
          )}
          {havePermission('Delete Component') ? (
            <i
              className="icon-delete"
              onClick={(e: React.MouseEvent<HTMLLIElement>) => {
                e.stopPropagation();
                Confirm({
                  message: t('delete_confirmation'),
                  onConfirm: () => remove(state.id),
                });
              }}
            />
          ) : (
            ''
          )}
        </div>
      }
    />
  );
};

export default ShowMaterial;
